import React from 'react';

const ErrorMessage = ({ message, onDismiss, className = '', positionClass = 'top-10 right-0 left-0' }) => {
  if (!message) return null;

  return (
    <div
      className={`w-full bg-red-100 text-red-500 text-center absolute shadow-2xl p-4 py-8 border-red-400 border-[1px] rounded-xl ${positionClass} hover:cursor-pointer z-50 ${className}`}
      onClick={onDismiss}
    >
      {message}
    </div>
  );
};

export default ErrorMessage;
